(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('back-to-top')) {
    customElements.define(
      'back-to-top',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.mediaQuery = window.matchMedia('(min-width: 990px)');
          this.update = this.update.bind(this);
          this.changeScrollContainer = this.changeScrollContainer.bind(this);

          this.button?.addEventListener('click', () => {
            this.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
          });
          this.mediaQuery.addEventListener('change', this.changeScrollContainer);
          this.changeScrollContainer();
        }

        disconnectedCallback() {
          this.scrollTarget?.removeEventListener('scroll', this.update);
          this.mediaQuery?.removeEventListener('change', this.changeScrollContainer);
        }

        changeScrollContainer() {
          this.scrollTarget?.removeEventListener('scroll', this.update);
          this.scrollContainer = this.mediaQuery.matches
            ? document.querySelector('.page-wrapper') || document.scrollingElement
            : document.scrollingElement;
          this.scrollTarget = this.mediaQuery.matches ? this.scrollContainer : document;
          this.scrollTarget.addEventListener('scroll', this.update, { passive: true });
          this.update();
        }

        update() {
          const maximum = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;
          const progress = maximum > 0 ? Math.min(1, Math.max(0, this.scrollContainer.scrollTop / maximum)) : 0;
          this.style.setProperty('--scroll-progress', progress.toFixed(4));
          this.style.setProperty('--scroll-progress-percent', `${(progress * 100).toFixed(2)}%`);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
